import Marquee from 'react-fast-marquee'

export default function HeaderTop() {
  const texts = [
    "Free Shipping on orders above Rs. 1,800",
    "Get 5% Flat Discount on order above Rs. 1,000",
    "Get 7% Flat Discount on order above Rs. 2,500",
    "Flat Rs. 1200 Off on orders above Rs. 10,000",
  ]
  const customStyle = {
    background: '#84d2e6',
    color: 'white',
    fontWeight: '500',
    padding: '5px 10px',
    fontSize: '1.25rem',
    letterSpacing: '1px',
    // position: 'fixed',
    // top:10
  }

  return (
    <div className='' style={customStyle}>
      <Marquee pauseOnHover speed={50}>
        {texts.map((text, index) => (
          <div key={index} style={{ marginInline: '5.5rem' }}>
            {text}
          </div>
        ))}
      </Marquee>
    </div>
  )
}
